// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1v9Do","paramInput":"JobSimulator_paramInput__MMkVp","input":"JobSimulator_input__1fKkd"};